import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/ProposedCreditLimits/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/ProposedCreditLimits/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/ProposedCreditLimits/GetById`, payload),
    Add: (payload) => Repository.post(`/api/ProposedCreditLimits/Add`, payload),
    Edit: (payload) => Repository.post(`/api/ProposedCreditLimits/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/ProposedCreditLimits/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/ProposedCreditLimits/ChangeStatus`, payload),
}
